import { connect } from 'react-redux';
import PrivateRoute from '../components/common/PrivateRoute';

const mapStateToProps = (state) => {
  return {
    loggedIn: state.signin.loggedIn,
    proxyLoggedIn: state.proxyLoginUser.proxyLoggedIn,
    user: state.accountSetting.user,
  };
};

const mapDispatchToProps = () => {
  return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/containers/PrivateRoute.js